import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { timesheetEndpoints } from '@/lib/api/endpoints';
import { timesheetKeys } from '@/lib/queryKeys';
import type { OpenClockSession } from '@/types/timesheet';

/**
 * Who is on the clock right now, with each session's age and lock state.
 *
 * The office previously had no way to see an open session at all, so a
 * technician blocked by a forgotten clock-out had to phone it in and nobody
 * could find the row responsible. Sessions flagged `needsAttention` are past the
 * forgotten-clock-out cap.
 */
export function useOpenClockSessions(
  enabled = true,
  options: { refetchIntervalMs?: number; showErrorToast?: boolean } = {},
) {
  return useApiQuery<OpenClockSession[]>({
    queryKey: timesheetKeys.openSessions(),
    queryFn: () => apiGet<OpenClockSession[]>(operationsClient, timesheetEndpoints.openSessions()),
    enabled,
    refetchInterval: options.refetchIntervalMs,
    showErrorToast: options.showErrorToast,
  });
}
